import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ToastLink {
  url: string;
  text: string;
  external?: boolean;
}

export interface ToastMessage {
  type: 'warn' | 'success' | 'info';
  title: string;
  message: string;
  link?: ToastLink;     // << neu
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  private messageSubject = new BehaviorSubject<ToastMessage | null>(null);
  message$ = this.messageSubject.asObservable();

  show(
    type: 'warn' | 'success' | 'info',
    title: string,
    message: string,
    link?: ToastLink
  ) {
    this.messageSubject.next({ type, title, message, link });
  }
}
